export const customPalette = {
  EditorBackground: {
    default: '#292929',
  },
  AccentBlue: '#375EFF',
  AccentViolet: '#846AE9',
  Pink: '#E93571',
  Black: {
    1: '#00000',
    2: '#141414',
    3: '#292929',
  },
  Gray: {
    1: '#3E3E3E',
    2: 'rgba(0, 0, 0, 0.40)',
  },
  White: {
    white: '#FFFFFF',
    10: 'rgba(255, 255, 255, 0.10)',
    16: 'rgba(255, 255, 255, 0.16)',
    32: 'rgba(255, 255, 255, 0.32)',
    40: 'rgba(255, 255, 255, 0.40)',
    56: 'rgba(255, 255, 255, 0.56)',
  },
}
